export default "__VITE_ASSET__CKx7wkIe__"